// src/_config/db_paths.ts
// ─────────────────────────────────────────────────────────────
// CONFIG: Firebase RTDB path ทั้งหมดในโปรเจ็ค
// แก้ที่นี่ที่เดียว มีผลทั้งระบบ
// ─────────────────────────────────────────────────────────────

// ─── Root ─────────────────────────────────────────────────────
const ROOT = 'ktfc'                          // root path ของทั้งระบบ ktfc

// ─── Customer data paths ──────────────────────────────────────
export const DB_CUST_ROOT        = `${ROOT}`
export const DB_DATA_A           = `${ROOT}/data_a/customer`          // รอตรวจสอบ
export const DB_DATA_B           = `${ROOT}/data_b/customer`          // อนุมัติแล้ว รอจ่าย
export const DB_DATA_C           = `${ROOT}/data_c/customer`          // กำลังผ่อน (active)
export const DB_DATA_D           = `${ROOT}/data_d/customer`          // ปิดบัญชี
export const DB_DATA_E           = `${ROOT}/data_e/customer`          // หนี้เสีย

export const DB_CUST_A  = (id: string) => `${DB_DATA_A}/${id}`
export const DB_CUST_B  = (id: string) => `${DB_DATA_B}/${id}`
export const DB_CUST_C  = (id: string) => `${DB_DATA_C}/${id}`
export const DB_CUST_D  = (id: string) => `${DB_DATA_D}/${id}`
export const DB_CUST_E  = (id: string) => `${DB_DATA_E}/${id}`

// ─── Finance paths ────────────────────────────────────────────
export const DB_LOAN             = `${ROOT}/loan`                     // ข้อมูลสินเชื่อ
export const DB_PAYIN            = `${ROOT}/payin`                    // งวดชำระ
export const DB_PAYOUT           = `${ROOT}/payout`                   // ประวัติจ่ายเงิน
export const DB_STATUS           = `${ROOT}/status`                   // สถานะลูกค้า
export const DB_BAD_DEBT         = `${ROOT}/badDebt`                  // ข้อมูลหนี้เสีย

export const DB_LOAN_BY_ID      = (id: string) => `${DB_LOAN}/${id}`
export const DB_PAYIN_BY_ID     = (id: string) => `${DB_PAYIN}/${id}`
export const DB_PAYOUT_BY_ID    = (id: string) => `${DB_PAYOUT}/${id}`
export const DB_STATUS_BY_ID    = (id: string) => `${DB_STATUS}/${id}`
export const DB_BAD_DEBT_BY_ID  = (id: string) => `${DB_BAD_DEBT}/${id}`

/// ─── Loan Following ─────────────────────────────────────────────
export const DB_FOLLOWING                   = `${ROOT}/following`                // ข้อมูลติดตามลูกค้า
export const DB_FOLLOWING_BY_ID             = (id: string) => `${DB_FOLLOWING}/${id}`
export const DB_FOLLOWING_CUSTOM_ZONE       = `${ROOT}/customZone`          // ข้อมูลติดตามลูกค้าแบบแยกโซน
export const DB_FOLLOWING_CUSTOM_ZONE_BY_ID = (id: string, p0: string) => `${DB_FOLLOWING_CUSTOM_ZONE}/${id}`

// ─── Config data paths ────────────────────────────────────────
export const DB_DATA_ROOT        = `${ROOT}/data`                     // root ข้อมูล config
export const DB_REGISTER_FORM    = `${ROOT}/data/registerform`        // config ฟอร์มลงทะเบียน
export const DB_POINT_CONFIG     = `${ROOT}/data/point`               // config คะแนน
export const DB_PHOTO            = `${ROOT}/data/photo`               // รูปภาพลูกค้า
export const DB_REG_CUS          = `${ROOT}/data/registercustomer`    // ข้อมูลลูกค้าลงทะเบียน
export const DB_REG_CUS_BY_ID    = (id: string) => `${DB_REG_CUS}/${id}` // ข้อมูลลูกค้าลงทะเบียน จาก id

export const DB_PHOTO_BY_ID     = (customerId: string)             => `${DB_PHOTO}/${customerId}`
export const DB_PHOTO_ITEM      = (customerId: string, photoId: string) => `${DB_PHOTO}/${customerId}/${photoId}`

export const DB_SLIP_BY_ID      = (customerId: string) => `${ROOT}/slip/${customerId}`   // รูปสลิปชำระเงิน
export const DB_SLIP_BY_ITEM_ID = (customerId: string, itemId: string) => `${ROOT}/slip/${customerId}/${itemId}`

// ─── Admin paths ──────────────────────────────────────────────
export const DB_ADMIN            = `admin`                            // ข้อมูลพนักงาน
export const DB_FOLLOWER         = `follower`                         // โซนพนักงานติดตาม
export const DB_ACTION_LOG       = `actionLog`                        // log การใช้งาน
export const DB_PIN_SAFE         = `pinSafe`                          // PIN ปกติ
export const DB_PIN_DANGER       = `pinDanger`                        // PIN ล็อค

export const DB_ADMIN_BY_ID     = (uid: string) => `${DB_ADMIN}/${uid}`
export const DB_FOLLOWER_BY_ID  = (uid: string) => `${DB_FOLLOWER}/${uid}`
export const DB_PIN_SAFE_BY_ID  = (uid: string) => `${DB_PIN_SAFE}/${uid}`
export const DB_PIN_DANGER_BY_ID = (uid: string) => `${DB_PIN_DANGER}/${uid}`
export const DB_LOG_ENTRY       = (logId: string) => `${DB_ACTION_LOG}/${logId}`

// ─── Misc paths ──────────────────────────────────────────────
export const DB_LOAN_HISTORY     = `${ROOT}/loanHistory`              // snapshot ประวัติปรับดอก/ล้มยอด
export const DB_LOAN_HISTORY_BY_ID = (id: string) => `${DB_LOAN_HISTORY}/${id}`
export const DB_SCORES           = `${ROOT}/scores`                   // คะแนนลูกค้า
export const DB_SCORES_BY_ID     = (id: string) => `${DB_SCORES}/${id}`

// ─── Field Collection (รับเงินภาคสนาม รอลงบัญชี) ───
export const DB_COLLECT          = `${ROOT}/collect`
export const DB_COLLECT_BY_ID    = (id: string) => `${DB_COLLECT}/${id}`
// รูปแยกออกจาก receipt (กัน node collect บวมจนอ่านไม่ได้)
export const DB_COLLECT_IMG        = `${ROOT}/collectImage`
export const DB_COLLECT_IMG_ITEM   = (cid: string, rid: string) => `${DB_COLLECT_IMG}/${cid}/${rid}`

// ─── Archive Version ─────────────────────────────────────────────
export const DB_ARCHIVE_VERSION       = `${ROOT}/archiveVersion`
export const DB_ARCHIVE_VERSION_BY_ID = (id: string) => `${DB_ARCHIVE_VERSION}/${id}`